import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

// TODO - remove once new mechanism has rolled out to prod
// on whiteboards side, we will register ourself as both clients to fast-5
export const CONFLUENCE_WHITEBOARD_CLIENT_ID: ClientId = client('confluence-whiteboard');

const CONFLUENCE_WHITEBOARD_CLIENT_ID_PREFIX = 'confluence-whiteboard';

export const getConfluenceWhiteboardClientId = (contentId: string): ClientId =>
	client(`${CONFLUENCE_WHITEBOARD_CLIENT_ID_PREFIX}-${contentId}`);
